import { useBILogger } from '@wix/fe-essentials/react';
import { useCallback, useMemo } from 'react';
import { getPluginsEditorType } from '../../../utils';
import { PluginsHostApiContext } from '@wix/editor-platform-host-integration-apis';

const EVENT_ID = {
  PLUGIN_REMOVE_CLICK: 106,
  PLUGIN_HOVER: 208,
};

export type UninstallPluginEventPayload = {
  plugin_id: string;
  host_app_id: string;
} & PluginsHostApiContext;

export type HoverPluginEventPayload = {
  origin: 'plugin_market_card' | 'plugin_manage_card';
  action_context: string;
};

export const usePluginsBi = () => {
  const logger = useBILogger();
  const editorType = getPluginsEditorType();

  const defaultPluginEvents = useMemo(
    () => ({
      target_type: 'widget_plugins',
    }),
    [],
  );

  const pluginRemoveClick = useCallback(
    (payload: UninstallPluginEventPayload) => {
      logger.log({
        ...payload,
        ...defaultPluginEvents,
        method: 'click',
        evid: EVENT_ID.PLUGIN_REMOVE_CLICK,
        editorType,
      });
    },
    [defaultPluginEvents, logger, editorType],
  );

  const pluginHover = (payload: HoverPluginEventPayload) => {
    logger.log({
      ...payload,
      ...defaultPluginEvents,
      evid: EVENT_ID.PLUGIN_HOVER,
    });
  };

  return {
    pluginRemoveClick,
    pluginHover,
  };
};
